<div class="flex h-full flex-col" *transloco="let t">
  <div class="shrink-0 pt-4">
    @if (mode === "creation") {
      <IStepper [steps]="steps()" />
    } @else {
      <ITabsSelector class="w-full shrink-0 border-b" [(value)]="currentStep">
        <button iTab [value]="'audience'">
          {{ t("common.audience") }}
        </button>
        <button iTab [value]="'blacklist'">
          {{ t("common.blacklist") }}
        </button>
      </ITabsSelector>
    }
  </div>

  <div class="min-h-0 w-full flex-1 overflow-auto">
    @if (currentStep() === "audience") {
      <app-dsp-audiences-selector
        [selectedAudiences]="audiences()"
        (selectedAudiencesChange)="audiences.set($event)"
        [audienceType]="StrategyDspAudienceType.WHITELIST"
        [style]="'outlined'"
      />
    } @else {
      <app-dsp-audiences-selector
        [selectedAudiences]="blacklistedAudiences()"
        (selectedAudiencesChange)="blacklistedAudiences.set($event)"
        [audienceType]="StrategyDspAudienceType.BLACKLIST"
        [style]="'outlined'"
      />
    }
  </div>

  <div class="flex w-full shrink-0 items-center gap-2 border-t bg-white p-4">
    <div class="flex w-full justify-between">
      <div class="flex items-center gap-2">
        <button iButton variant="secondary" (click)="cancel()">{{ t("common.cancel") }}</button>
        <div class="text-muted-foreground">{{ hintMessage() }}</div>
      </div>
      <div class="flex items-center gap-2">
        <div class="text-muted-foreground">
          {{ t("dsp-audiences-selector.x_audiences", { count: totalAudiences() }) }} ·
          {{ t("dsp-audiences-selector.x_blacklist", { count: totalBlacklistedAudiences() }) }}
        </div>
        @if (mode === "creation") {
          @if (currentStep() === "blacklist") {
            <button iButton variant="secondary" (click)="back()">{{ t("common.back") }}</button>
            <button iButton [disabled]="!canSaveAudiences()" (click)="save()">
              {{ t("common.create") }}
            </button>
          } @else {
            <button iButton [disabled]="!canGoNext()" (click)="next()">{{ t("common.next") }}</button>
          }
        } @else {
          <button iButton [disabled]="!canSaveAudiences()" (click)="save()">
            {{ t("common.save") }}
          </button>
        }
      </div>
    </div>
  </div>
</div>
